import { jsx as _jsx } from "react/jsx-runtime";
import useFeaturedContentData from "../../../hooks/useFeaturedContentData";
import FeaturedDataElement from "../../atoms/FeaturedDataElement";
var SecondaryFeaturedContent = function () {
    var secondary = useFeaturedContentData().secondary;
    if (!secondary || Array.isArray(secondary)) {
        return _jsx("div", {});
    }
    var additionalLabel = secondary.additionalLabel, label = secondary.label, toolTipText = secondary.toolTipText, type = secondary.type, value = secondary.value;
    return (_jsx(FeaturedDataElement, { additionalLabel: additionalLabel, dataCy: "secondary-featured-content.data-element", label: label, isLargerText: true, toolTipText: toolTipText, type: type, value: value }));
};
export default SecondaryFeaturedContent;
//# sourceMappingURL=SecondaryFeaturedContent.js.map